import {
  DEFAULT_BATCH_SIZE,
  TaskQueue,
} from 'packages/task-man/service/pickup/task-queue';
import useSWRImmutable from 'swr/immutable';
import { multitaskBatchIDAtom } from 'packages/at-shell/state/recoil/ui';
import { useRecoilValue } from 'recoil';
import { swrKey } from 'packages/task-man/service/pickup/use-task-queue';

export const usePeekUnassignedTasks = (
  taskQueue?: TaskQueue,
  n = DEFAULT_BATCH_SIZE
) => {
  const multitaskBatchID = useRecoilValue(multitaskBatchIDAtom);
  const {
    data: unassignedTasks,
    error: unassignedTasksError,
    isLoading: isLoadingUnassignedTasks,
  } = useSWRImmutable(
    taskQueue ? swrKey(taskQueue, multitaskBatchID, 'unassigned-tasks') : null,
    () => taskQueue?.peekMany(n)
  );
  return { unassignedTasks, unassignedTasksError, isLoadingUnassignedTasks };
};
